module.exports = __webpack_public_path__ + "media/interestedArticle.c9aa08cd.mp3";